import type { Video } from "@/types/video";

export const videos: Video[] = [
  {
    id: "v01",
    title: "国庆档新片票房破纪录 导演深度解读幕后故事",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20premiere%20red%20carpet%20scene%20with%20warm%20golden%20spotlights%20and%20blurred%20crowd%2C%20dramatic%20high%20contrast%20lighting%2C%20moody%20atmosphere%2C%20professional%20movie%20still%20photography%2C%20rich%20orange%20and%20dark%20tones%2C%20editorial%20composition&width=800&height=450&seq=rpvideo-01&orientation=landscape",
    category: "film-news",
    categoryName: "影视资讯",
    type: "资讯",
    region: "中国",
    duration: "08:42",
    year: 2026,
    publishDate: "2026-10-08",
    description:
      "国庆档多部新片同步上映，总票房刷新同期纪录，导演与主创团队首次公开分享创作幕后与拍摄细节。",
    content:
      "今年国庆档电影市场热度空前，多部类型各异的新片集中上映，总票房刷新同期历史纪录。本期视频带你走进片场，与导演面对面，聊聊那些观众看不到的幕后故事。从剧本打磨到实景搭建，从演员试镜到后期调色，每一个环节都凝聚着团队的心血。主持人还现场体验了一段特技动作的拍摄流程，还原电影镜头的诞生过程。",
    tags: ["国庆档", "票房", "导演访谈", "院线新片"],
    views: 128600,
    author: "日皮视频·资讯组",
    featured: true,
  },
  {
    id: "v02",
    title: "科幻巨制《星海边境》发布首支正式预告",
    cover:
      "https://readdy.ai/api/search-image?query=epic%20science%20fiction%20space%20scene%20with%20giant%20spaceship%20silhouette%20and%20distant%20planet%2C%20deep%20orange%20nebula%20glow%2C%20dramatic%20cinematic%20lighting%2C%20high%20contrast%2C%20detailed%20film%20still%2C%20atmospheric%20vista%2C%20professional%20production%20quality&width=800&height=450&seq=rpvideo-02&orientation=landscape",
    category: "film-news",
    categoryName: "影视资讯",
    type: "预告片",
    region: "美国",
    duration: "02:36",
    year: 2026,
    publishDate: "2026-10-05",
    description:
      "备受期待的科幻巨制《星海边境》放出首支正式预告，宏大世界观与顶级视效引发全网热议。",
    content:
      "《星海边境》耗时四年打造，讲述人类在遥远星系中寻找新家园的故事。首支预告中，巨型飞船、异星地貌与紧张的空战场面悉数亮相，配乐由知名交响乐团现场录制。制作方透露影片采用了大量实景微缩模型与数字特效结合的方式，力求呈现真实的宇宙质感。预告发布仅一天，播放量便突破千万。",
    tags: ["科幻", "预告片", "视效", "宇宙"],
    views: 96400,
    author: "日皮视频·资讯组",
  },
  {
    id: "v03",
    title: "年度悬疑剧《雾城》定档 群像海报同步曝光",
    cover:
      "https://readdy.ai/api/search-image?query=misty%20rainy%20city%20street%20at%20night%20with%20single%20street%20lamp%20and%20wet%20reflections%2C%20suspenseful%20mood%20with%20orange%20warm%20light%20against%20cold%20shadows%2C%20cinematic%20film%20still%2C%20high%20contrast%2C%20mysterious%20atmosphere%2C%20editorial%20photography&width=800&height=450&seq=rpvideo-03&orientation=landscape",
    category: "film-news",
    categoryName: "影视资讯",
    type: "资讯",
    region: "中国",
    duration: "05:18",
    year: 2026,
    publishDate: "2026-10-02",
    description:
      "年度悬疑剧《雾城》正式宣布定档，官方同步放出九人群像海报，错综复杂的人物关系引发猜测。",
    content:
      "《雾城》以一桩悬而未决的旧案为线索，串联起一座城市中多个家庭的命运。此次曝光的群像海报中，九位主要角色神态各异，画面色调阴沉，暗示剧情走向扑朔迷离。导演表示，该剧最大的看点在于人物动机的多重反转，希望观众在推理的同时也能感受到人性的温度。剧集将于下月上线。",
    tags: ["悬疑", "定档", "剧集", "群像"],
    views: 73200,
    author: "日皮视频·剧集组",
  },
  {
    id: "v04",
    title: "国际电影节获奖名单公布 华语影片斩获大奖",
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20international%20film%20festival%20award%20ceremony%20stage%20with%20golden%20statue%20and%20warm%20spotlight%20beams%2C%20formal%20glamorous%20atmosphere%2C%20cinematic%20photography%2C%20rich%20amber%20and%20dark%20tones%2C%20high%20contrast%20elegant%20composition&width=800&height=450&seq=rpvideo-04&orientation=landscape",
    category: "film-news",
    categoryName: "影视资讯",
    type: "资讯",
    region: "法国",
    duration: "06:55",
    year: 2026,
    publishDate: "2026-09-28",
    description:
      "本届国际电影节获奖名单揭晓，多部华语影片入围并斩获重要奖项，再次刷新国际影响力。",
    content:
      "本届国际电影节评委阵容强大，来自世界各地的佳作同台竞技。华语影片在最佳导演与最佳摄影两个重要单元中获奖，评审团盛赞其在影像语言与叙事结构上的创新。导演在领奖时表示，这份荣誉属于整个幕后团队。本期视频完整梳理获奖名单，并带来现场花絮。",
    tags: ["电影节", "获奖", "华语电影", "国际"],
    views: 58900,
    author: "日皮视频·资讯组",
  },
  {
    id: "v05",
    title: "经典IP宣布重启 全新版本官宣主演阵容",
    cover:
      "https://readdy.ai/api/search-image?query=dramatic%20studio%20reveal%20of%20a%20classic%20film%20poster%20silhouette%20unveiled%20under%20warm%20stage%20lights%2C%20anticipation%20and%20spotlight%20mood%2C%20cinematic%20still%2C%20high%20contrast%2C%20amber%20and%20charcoal%20palette%2C%20editorial%20composition&width=800&height=450&seq=rpvideo-05&orientation=landscape",
    category: "film-news",
    categoryName: "影视资讯",
    type: "资讯",
    region: "中国",
    duration: "04:30",
    year: 2026,
    publishDate: "2026-09-22",
    description:
      "承载一代人记忆的经典IP正式宣布重启，官方一次性公布主演阵容，新旧对比引发热烈讨论。",
    content:
      "这是该经典IP时隔十二年的首次重启，制作方承诺在保留原作精神内核的基础上，用全新的技术手段与叙事视角呈现故事。此次官宣的主演阵容兼顾实力派与新生代，导演表示选角历时半年，只为找到最贴合角色气质的演员。发布会现场还播放了概念先导片，勾起无数观众的回忆。",
    tags: ["经典IP", "重启", "主演阵容", "情怀"],
    views: 84100,
    author: "日皮视频·资讯组",
  },
  {
    id: "v06",
    title: "电影《长风》正式开机 全实景拍摄引期待",
    cover:
      "https://readdy.ai/api/search-image?query=film%20set%20on%20open%20grassland%20with%20camera%20crew%20and%20period%20costume%20actors%20silhouettes%2C%20golden%20hour%20sunlight%2C%20warm%20cinematic%20tones%2C%20high%20contrast%2C%20atmospheric%20production%20still%2C%20documentary%20feel%2C%20detailed%20composition&width=800&height=450&seq=rpvideo-06&orientation=landscape",
    category: "film-news",
    categoryName: "影视资讯",
    type: "花絮",
    region: "中国",
    duration: "07:12",
    year: 2026,
    publishDate: "2026-09-18",
    description:
      "历史题材电影《长风》在草原正式开机，全实景拍摄与大量真实道具成为最大看点。",
    content:
      "《长风》讲述了主人公在动荡年代中的成长与抉择。为了还原真实的历史质感，剧组辗转多地取景，搭建了超过三万平米的外景基地。开机仪式上，导演带领全体主创绕场一周，祈求拍摄顺利。制片人透露，影片将坚持实景拍摄，尽量减少绿幕使用，希望观众能感受到镜头里的风与尘土。",
    tags: ["历史", "开机", "实景", "制作"],
    views: 47600,
    author: "日皮视频·资讯组",
  },
  {
    id: "v07",
    title: "秋季档剧集前瞻 十部待播作品一次盘点",
    cover:
      "https://readdy.ai/api/search-image?query=stack%20of%20colorful%20film%20reels%20and%20clapperboards%20arranged%20on%20a%20dark%20table%20under%20warm%20studio%20lighting%2C%20cinematic%20editorial%20still%2C%20high%20contrast%2C%20amber%20and%20charcoal%20tones%2C%20rich%20texture%2C%20detailed%20composition&width=800&height=450&seq=rpvideo-07&orientation=landscape",
    category: "film-news",
    categoryName: "影视资讯",
    type: "盘点",
    region: "中国",
    duration: "10:05",
    year: 2026,
    publishDate: "2026-09-12",
    description:
      "秋季档即将到来，本期视频一次性盘点十部最值得期待的待播剧集，题材覆盖全面。",
    content:
      "秋季档向来是剧集市场的黄金时段。本期视频从上线的数十部待播作品中，综合题材、阵容与制作水准，精选出十部最值得关注的作品。既有高概念悬疑，也有温暖治愈的生活剧，还有热血励志的行业剧。每部作品都附有主创阵容与看点解析，帮你提前排好追剧清单。",
    tags: ["秋季档", "剧集", "盘点", "待播"],
    views: 62400,
    author: "日皮视频·剧集组",
  },
  {
    id: "v08",
    title: "三分钟看懂今年最火的科幻设定",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20science%20fiction%20concept%20with%20glowing%20geometric%20grid%20and%20floating%20light%20particles%20over%20dark%20space%2C%20warm%20orange%20glow%20accents%2C%20cinematic%20high%20contrast%2C%20futuristic%20atmosphere%2C%20editorial%20graphic%20still&width=800&height=450&seq=rpvideo-08&orientation=landscape",
    category: "short-video",
    categoryName: "短视频",
    type: "解说",
    region: "中国",
    duration: "03:08",
    year: 2026,
    publishDate: "2026-10-09",
    description:
      "今年科幻作品中出现的高概念设定层出不穷，本期用三分钟帮你一次理清核心逻辑。",
    content:
      "从时间循环到多世界诠释，从意识上载到人工智能觉醒，今年的科幻作品把脑洞开到了极致。本期视频选取了最具代表性的五个设定，用最通俗的语言解释它们背后的科学逻辑与戏剧魅力。即使没看过原著，也能听懂这些设定为什么让人欲罢不能。",
    tags: ["科幻", "解说", "设定", "科普"],
    views: 156800,
    author: "日皮视频·短片组",
    featured: true,
  },
  {
    id: "v09",
    title: "街头采访 你心中的年度最佳影片是哪部",
    cover:
      "https://readdy.ai/api/search-image?query=street%20interview%20scene%20with%20people%20holding%20microphone%20in%20a%20warm%20evening%20city%20street%2C%20bokeh%20lights%20in%20background%2C%20candid%20documentary%20style%2C%20high%20contrast%20orange%20hues%2C%20cinematic%20still%2C%20lively%20atmosphere&width=800&height=450&seq=rpvideo-09&orientation=landscape",
    category: "short-video",
    categoryName: "短视频",
    type: "访谈",
    region: "中国",
    duration: "04:47",
    year: 2026,
    publishDate: "2026-10-06",
    description:
      "我们走上街头，随机采访路人，听听大家心中的年度最佳影片是哪一部，理由五花八门。",
    content:
      "有人偏爱催泪的家庭故事，有人钟情燃到爆的动作大片，也有人为一部小众文艺片反复走进影院。不同的答案背后，是每个人独特的观影记忆。本期街采走遍城市多个角落，收集了上百份回答，最后统计出最受欢迎的三部作品。你的年度最佳又是哪一部呢？",
    tags: ["街采", "访谈", "年度影片", "观众"],
    views: 91200,
    author: "日皮视频·短片组",
  },
  {
    id: "v10",
    title: "一分钟混剪 燃向动作名场面合集",
    cover:
      "https://readdy.ai/api/search-image?query=explosive%20action%20movie%20montage%20with%20sparks%20flying%20and%20silhouetted%20figures%20mid%20motion%2C%20intense%20dramatic%20lighting%2C%20orange%20fire%20glow%20against%20deep%20shadow%2C%20high%20contrast%20cinematic%20still%2C%20dynamic%20energy&width=800&height=450&seq=rpvideo-10&orientation=landscape",
    category: "short-video",
    categoryName: "短视频",
    type: "混剪",
    region: "美国",
    duration: "01:12",
    year: 2026,
    publishDate: "2026-10-03",
    description:
      "把今年最燃的动作名场面剪在一起，一分钟高能不断，肾上腺素直接拉满。",
    content:
      "本期混剪精选了年度动作片中最具冲击力的镜头，从追车到近身格斗，从爆炸到高空跳跃，节奏紧凑、卡点精准。剪辑师还特别调校了音效层次，让每一次撞击都更有分量。戴上耳机观看效果更佳，建议全屏播放。",
    tags: ["动作", "混剪", "名场面", "高燃"],
    views: 203500,
    author: "日皮视频·剪辑组",
  },
  {
    id: "v11",
    title: "幕后花絮 特效团队如何打造巨兽",
    cover:
      "https://readdy.ai/api/search-image?query=behind%20the%20scenes%20visual%20effects%20studio%20with%20green%20screen%20and%20technicians%20working%20on%20computers%2C%20warm%20desk%20lighting%2C%20high%20contrast%20cinematic%20documentary%20still%2C%20amber%20and%20charcoal%20tones%2C%20detailed%20composition&width=800&height=450&seq=rpvideo-11&orientation=landscape",
    category: "short-video",
    categoryName: "短视频",
    type: "花絮",
    region: "美国",
    duration: "06:20",
    year: 2026,
    publishDate: "2026-09-30",
    description:
      "银幕上巨大的怪兽究竟是怎么做出来的？本期带你走进特效工作室，揭秘制作全流程。",
    content:
      "一只巨型怪兽的诞生，远不止是电脑里的建模那么简单。从骨骼绑定、肌肉肌肉解算，到皮肤纹理与毛发渲染，每一步都需要数十位艺术家的协作。本期花絮记录了一个镜头的完整制作过程，你还会看到演员如何在绿幕前对着空气表演出惊恐与对抗。",
    tags: ["特效", "花絮", "幕后", "制作"],
    views: 118700,
    author: "日皮视频·短片组",
  },
  {
    id: "v12",
    title: "趣味解说 那些被你忽略的电影彩蛋",
    cover:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20framed%20movie%20posters%20and%20hidden%20symbols%20on%20a%20warm%20lit%20wall%2C%20mysterious%20easter%20egg%20theme%2C%20cinematic%20high%20contrast%2C%20amber%20tones%2C%20editorial%20still%2C%20detailed%20texture&width=800&height=450&seq=rpvideo-12&orientation=landscape",
    category: "short-video",
    categoryName: "短视频",
    type: "解说",
    region: "中国",
    duration: "05:33",
    year: 2026,
    publishDate: "2026-09-26",
    description:
      "很多电影里都藏着导演精心设计的彩蛋，本期盘点那些一眼错过的隐藏细节。",
    content:
      "也许是一闪而过的背景文字，也许是配乐里埋下的旋律动机，又或者是道具上重复出现的数字，导演们总喜欢在不经意间埋下小心思。本期视频挑选了十个最有趣的彩蛋，配上原片截图逐帧讲解，看完之后你一定会想重新刷一遍这些电影。",
    tags: ["彩蛋", "解说", "细节", "趣味"],
    views: 87400,
    author: "日皮视频·短片组",
  },
  {
    id: "v13",
    title: "短片推荐 五分钟治愈系日常故事",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20small%20cafe%20interior%20in%20warm%20afternoon%20sunlight%20with%20steaming%20cup%20and%20plants%2C%20soft%20comforting%20atmosphere%2C%20gentle%20cinematic%20still%2C%20warm%20orange%20and%20cream%20tones%2C%20editorial%20composition&width=800&height=450&seq=rpvideo-13&orientation=landscape",
    category: "short-video",
    categoryName: "短视频",
    type: "短片",
    region: "日本",
    duration: "05:10",
    year: 2026,
    publishDate: "2026-09-20",
    description:
      "忙碌的生活里，也需要一点温柔的停顿。本期推荐几部五分钟就能看完的治愈系短片。",
    content:
      "这几部短片没有惊天动地的情节，只是把镜头对准普通人的日常：一间小咖啡馆、一次偶遇、一段安静的告别。正是这些细碎的瞬间，让人在快节奏的生活里重新找回平静。本期视频附上每部短片的看点与关键词，方便你随时点开观看。",
    tags: ["短片", "治愈", "日常", "推荐"],
    views: 69300,
    author: "日皮视频·短片组",
  },
  {
    id: "v14",
    title: "台词盘点 经典对白一次听个够",
    cover:
      "https://readdy.ai/api/search-image?query=typewriter%20resting%20on%20a%20desk%20with%20warm%20lamp%20light%20and%20scattered%20script%20pages%2C%20nostalgic%20writer%20theme%2C%20cinematic%20high%20contrast%2C%20amber%20and%20sepia%20tones%2C%20editorial%20still%2C%20rich%20texture&width=800&height=450&seq=rpvideo-14&orientation=landscape",
    category: "short-video",
    categoryName: "短视频",
    type: "盘点",
    region: "中国",
    duration: "07:45",
    year: 2026,
    publishDate: "2026-09-15",
    description:
      "有些台词一开口就让人起鸡皮疙瘩，本期盘点那些年被反复引用的经典对白。",
    content:
      "台词的魅力在于，它能用短短一句话，把角色的心境与故事的重量全部说出来。本期视频从近二十年的经典影视作品中，挑选出最深入人心的二十句对白，配合原片片段与简单背景解析，带你重温那些让人心头一颤的瞬间。",
    tags: ["台词", "盘点", "经典", "对白"],
    views: 79200,
    author: "日皮视频·剪辑组",
  },
  {
    id: "v15",
    title: "名场面混剪 燃到起鸡皮疙瘩的对决",
    cover:
      "https://readdy.ai/api/search-image?query=two%20silhouetted%20figures%20facing%20off%20in%20a%20dark%20space%20with%20dramatic%20orange%20backlight%20and%20floating%20embers%2C%20tense%20confrontation%2C%20high%20contrast%20cinematic%20still%2C%20epic%20atmosphere%2C%20detailed%20composition&width=800&height=450&seq=rpvideo-15&orientation=landscape",
    category: "hot-video",
    categoryName: "热门视频",
    type: "混剪",
    region: "中国",
    duration: "04:18",
    year: 2026,
    publishDate: "2026-10-10",
    description:
      "那些让人起鸡皮疙瘩的正面对决，配乐一响，气势全开，本期一次看个够。",
    content:
      "对决场面是影视作品最具感染力的时刻之一：音乐渐强、镜头拉近、呼吸放慢，然后一切在瞬间爆发。本期混剪精选了年度最震撼的多个对决片段，保留了原片的音画节奏，只用最克制的转场把它们串联起来。看到最后，你会发现真正让人热血沸腾的，往往是一个眼神。",
    tags: ["对决", "混剪", "名场面", "高燃"],
    views: 245600,
    author: "日皮视频·剪辑组",
    featured: true,
  },
  {
    id: "v16",
    title: "高能剪辑 反转不断的悬疑名场面",
    cover:
      "https://readdy.ai/api/search-image?query=detective%20examining%20clues%20on%20a%20dark%20desk%20under%20warm%20lamp%2C%20mystery%20investigation%20theme%2C%20suspenseful%20high%20contrast%20cinematic%20still%2C%20amber%20and%20shadow%20tones%2C%20detailed%20composition&width=800&height=450&seq=rpvideo-16&orientation=landscape",
    category: "hot-video",
    categoryName: "热门视频",
    type: "剪辑",
    region: "英国",
    duration: "06:02",
    year: 2026,
    publishDate: "2026-10-07",
    description:
      "层层反转、步步惊心，本期把最烧脑的悬疑名场面剪在一起，挑战你的推理能力。",
    content:
      "悬疑作品最迷人的地方，就是让你在自以为看懂的时候突然被推翻。本期剪辑挑选了多个以反转著称的名场面，从线索的铺陈到真相的揭晓，节奏一气呵成。视频还贴心地在关键节点插入提示，方便你暂停思考，看看自己能不能比主角更早猜到答案。",
    tags: ["悬疑", "反转", "剪辑", "烧脑"],
    views: 178300,
    author: "日皮视频·剪辑组",
  },
  {
    id: "v17",
    title: "热门片段 全网刷屏的经典一幕",
    cover:
      "https://readdy.ai/api/search-image?query=viral%20movie%20moment%20with%20lone%20figure%20standing%20in%20a%20vast%20warm%20lit%20plaza%2C%20iconic%20memorable%20scene%20energy%2C%20cinematic%20high%20contrast%2C%20golden%20hour%20tones%2C%20epic%20composition%2C%20detailed%20film%20still&width=800&height=450&seq=rpvideo-17&orientation=landscape",
    category: "hot-video",
    categoryName: "热门视频",
    type: "剪辑",
    region: "中国",
    duration: "03:40",
    year: 2026,
    publishDate: "2026-10-04",
    description:
      "有些画面一经播出就被全网反复引用，本期回顾那些刷屏的经典一幕。",
    content:
      "一段画面之所以能刷屏，往往是因为它精准击中了某种共同的情绪。本期视频整理了近期社交平台上传播最广的影视片段，并简单聊聊它们出圈的原因：有的是因为一句台词，有的是因为一个动作，还有的仅仅是因为那一刻恰好被镜头温柔地记录下来。",
    tags: ["热门", "刷屏", "片段", "回顾"],
    views: 189900,
    author: "日皮视频·剪辑组",
  },
  {
    id: "v18",
    title: "深度解说 十分钟看懂一部口碑佳作",
    cover:
      "https://readdy.ai/api/search-image?query=analytical%20film%20breakdown%20scene%20with%20multiple%20screens%20and%20timeline%20graphics%20in%20a%20warm%20lit%20room%2C%20editorial%20documentary%20style%2C%20high%20contrast%20amber%20tones%2C%20detailed%20cinematic%20composition&width=800&height=450&seq=rpvideo-18&orientation=landscape",
    category: "hot-video",
    categoryName: "热门视频",
    type: "解说",
    region: "中国",
    duration: "10:24",
    year: 2026,
    publishDate: "2026-09-27",
    description:
      "一部被低估的口碑佳作，本期用十分钟拆解它的叙事结构与隐藏主题。",
    content:
      "这部作品上映时票房平平，却在几年后凭借口碑被越来越多观众发现。本期解说从三个层面切入：它是如何用非线性叙事制造悬念的，又是如何通过色彩与构图暗示人物命运的，最后聊聊那个被许多人误读的结局。看完之后，你也许会想立刻找原片重看一遍。",
    tags: ["解说", "深度", "口碑", "结构"],
    views: 134700,
    author: "日皮视频·解说组",
  },
  {
    id: "v19",
    title: "高燃合集 年度动作戏份精选",
    cover:
      "https://readdy.ai/api/search-image?query=high%20octane%20chase%20scene%20with%20motion%20blur%20and%20glowing%20streaks%20through%20a%20dark%20city%20at%20night%2C%20warm%20orange%20light%20trails%2C%20cinematic%20high%20contrast%2C%20dynamic%20action%20still%2C%20detailed%20composition&width=800&height=450&seq=rpvideo-19&orientation=landscape",
    category: "hot-video",
    categoryName: "热门视频",
    type: "合集",
    region: "美国",
    duration: "05:58",
    year: 2026,
    publishDate: "2026-09-23",
    description:
      "从追车到肉搏，从飞跃到爆破，本期把年度最精彩的动作戏份打包放送。",
    content:
      "动作戏是电影工业的试金石。本期合集按场景类型将年度动作名场面分门别类：城市追车、近身格斗、高空跳跃与大规模爆破。每一段都保留了原片的音画冲击力，并用简洁的转场衔接，让你在两分钟内就进入高能状态。建议全屏、开声音观看。",
    tags: ["动作", "合集", "年度", "高燃"],
    views: 211400,
    author: "日皮视频·剪辑组",
  },
  {
    id: "v20",
    title: "催泪混剪 那些让人泪目的告别时刻",
    cover:
      "https://readdy.ai/api/search-image?query=emotional%20farewell%20scene%20with%20two%20figures%20silhouetted%20against%20a%20warm%20sunset%20horizon%2C%20soft%20melancholic%20mood%2C%20cinematic%20high%20contrast%2C%20golden%20hour%20tones%2C%20touching%20atmosphere%2C%20detailed%20film%20still&width=800&height=450&seq=rpvideo-20&orientation=landscape",
    category: "hot-video",
    categoryName: "热门视频",
    type: "混剪",
    region: "韩国",
    duration: "05:22",
    year: 2026,
    publishDate: "2026-09-19",
    description:
      "离别总是动人，本期混剪那些让人泪目的告别时刻，配乐一响眼泪就下来了。",
    content:
      "好的告别戏从不靠煽情，而是让你在克制的沉默里忽然懂得失去的重量。本期混剪选取了多部作品中最令人动容的告别片段，整段配乐由钢琴与弦乐交织，情绪层层推进。视频最后留了一段空白，让你可以安静地缓一缓。请备好纸巾再观看。",
    tags: ["催泪", "混剪", "告别", "情感"],
    views: 167800,
    author: "日皮视频·剪辑组",
  },
  {
    id: "v21",
    title: "全网热议 话题度最高的影视片段",
    cover:
      "https://readdy.ai/api/search-image?query=buzzworthy%20movie%20scene%20dramatized%20with%20glowing%20social%20media%20bubbles%20floating%20over%20a%20warm%20lit%20stage%2C%20modern%20trending%20theme%2C%20cinematic%20high%20contrast%2C%20orange%20and%20charcoal%20tones%2C%20editorial%20composition&width=800&height=450&seq=rpvideo-21&orientation=landscape",
    category: "hot-video",
    categoryName: "热门视频",
    type: "盘点",
    region: "中国",
    duration: "06:36",
    year: 2026,
    publishDate: "2026-09-14",
    description:
      "本期盘点近期讨论度最高的影视片段，看看大家都在为什么样的内容买单。",
    content:
      "一个片段能否引爆讨论，靠的不只是流量，更是它能否提供值得争辩的观点。本期盘点综合完播率、转发量与评论区热度，筛选出近期最具话题性的影视片段，并简单梳理每段讨论背后的争议点。看完之后，你或许也会想加入这场讨论。",
    tags: ["热议", "话题", "盘点", "潮流"],
    views: 143200,
    author: "日皮视频·剪辑组",
  },
];